<template>
  <el-button
    :disabled="disabled"
    :type="type"
    :loading="loading"
    :round="round"
    :size="size"
    plain
    :icon="icon"
    :circle="circle"
    @click="go($event)"
    :style="((right)?'float:right;':'')+';overflow:hidden'"
  >
    <slot />
  </el-button>
</template>

<script>
export default {
  name: "s-button",
  methods: {
    go(e) {
      if (!this.confirm) {
        this.$emit("execute", e);
      } else
        this.$confirm(this.confirm, "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        })
          .then(() => {
            this.$emit("execute", e);
          })
          .catch(() => {
            this.$emit("cancel", e);
          });
    }
  },
  props: {
    right: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "primary"
    },
    icon: {
      type: String,
      default:null
    },
    confirm: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: null
    }
  }
};
</script>
<style scoped>
button {
  padding: 3px;
}
</style>
